import React from 'react';
import { Loader2 } from 'lucide-react';

const CommonLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-32">
      <div className="flex items-center gap-2">
        <Loader2 className="h-6 w-6 animate-spin text-[#EB1C37]" />
        <span className="text-gray-600">Loading...</span>
      </div>
    </div>
  );
};

export default CommonLoader; 